export const NOTIFICATIONS_SEGMENT = 'notifications'
export const MY_READ_IN_APP_NOTIFICATIONS_SEGMENT = 'my-read-in-app-notifications'
export const MY_IN_APP_NOTIFICATIONS_SEGMENT = 'my-in-app-notifications'
export const MY_UNREAD_IN_APP_NOTIFICATIONS_SEGMENT = 'my-unread-in-app-notifications'
export const COUNT_SEGMENT = 'count'
